import React, { useEffect, useRef } from 'react';
import './chart.css';

const Chart: React.FC = () => {
	const chartRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const timer = setTimeout(() => {
			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							const bars = entry.target.querySelectorAll('.bar');
							bars.forEach((bar) => {
								const percentage = bar.getAttribute('data-percentage');
								if (percentage) {
									(bar as HTMLElement).style.height = percentage + "%";
								}
							});
							// observer.unobserve(entry.target); //animate once
						}
					});
				},
				{
					threshold: 0.3, // trigger when 30% of the chart is visible
					root: null,
					rootMargin: '0px',
				}
			);

			if (chartRef.current) {
				observer.observe(chartRef.current);
			}
		}, 100);

		return () => {
			clearTimeout(timer);
		}
	}, []);

	return (
		<div id='chart-wrapper' ref={chartRef}>
			<div className='bar-container'>
				<div className='bar' data-percentage='40'></div>
				<div className='bar' data-percentage='80'></div>
				<div className='bar' data-percentage='60'></div>
				<div className='bar' data-percentage='50'></div>
				<div className='spacer'></div>
				<span className='chart-span'>
					We are publishing open source models, tutorials, articles, and code on <a href="https://gitlab.com/hatch-institute" target='_blank' rel='noopener noreferrer'>Gitlab</a> to benefit the mental healthcare community
				</span>
			</div>
		</div>
	)
};

export default Chart;
